import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "video",
    "playButton",
    "playIcon",
    "pauseIcon",
    "progressBar",
    "muteButton",
    "muteIcon",
    "unmuteIcon",
  ]

  connect() {
    this.updateMuteButton()
  }

  togglePlay() {
    if (this.videoTarget.paused) {
      this.videoTarget.play()
      this.playIconTarget.classList.add("hidden")
      this.pauseIconTarget.classList.remove("hidden")
    } else {
      this.videoTarget.pause()
      this.playIconTarget.classList.remove("hidden")
      this.pauseIconTarget.classList.add("hidden")
    }
  }

  toggleMute() {
    this.videoTarget.muted = !this.videoTarget.muted
    this.updateMuteButton()
  }

  updateMuteButton() {
    if (this.videoTarget.muted) {
      this.muteIconTarget.classList.remove("hidden")
      this.unmuteIconTarget.classList.add("hidden")
    } else {
      this.muteIconTarget.classList.add("hidden")
      this.unmuteIconTarget.classList.remove("hidden")
    }
  }

  updateProgress() {
    const progress =
      (this.videoTarget.currentTime / this.videoTarget.duration) * 100
    this.progressBarTarget.value = progress
    this.progressBarTarget.style.background = `linear-gradient(to right, white ${progress}%, white ${progress}%, rgb(75, 85, 99) ${progress}%, rgb(75, 85, 99) 100%)`
  }

  seek() {
    const time =
      (this.progressBarTarget.value / 100) * this.videoTarget.duration
    this.videoTarget.currentTime = time
  }
}
